<template>
    <div>
        <div class="navmenu"
             :class="{ 'navmenu--completeMenu': completeMenu, 'navmenu--activated': mobileMenu }">
            <div class="navmenu__mobile">
                <router-link :to="{name:'home'}">
                    <img src="../assets/icons/magor.svg"
                        class="navmenu__logo"
                        alt="Magor"
                        title="Magor">
                </router-link>
                <img src="@/assets/icons/menu.svg"
                     @click="turnMobileMenu(true)"
                     class="navmenu__icon"
                     alt="Menu"
                     title="Menu">
            </div>
            <div class="navmenu__mobilemenu"
                 :class="{ 'navmenu__mobilemenu--activated': mobileMenu }">
                <img src="@/assets/icons/close.svg"
                     class="navmenu__mobilemenu__close"
                     @click="turnMobileMenu(false)"
                     alt="Fechar"
                     title="Fechar">

                <div class="navmenu__mobilemenu__header">
                    <img src="@/assets/icons/magor.svg"
                        class="navmenu__logo"
                        alt="Magor"
                        title="Magor">
                </div>

                <div class="navmenu__mobilemenu__content">
                    <div class="navmenu__mobilemenu__list">
                        <ul>
                            <li v-for="(item, index) in menu"
                                :key="index">
                                <router-link :to="{name: item.name}">{{ item.text }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'contato'}">Contato</router-link>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="navmenu__desktop"
                 :class="{ 'navmenu__desktop--completeMenu': completeMenu }">
                <div class="navmenu__icons">
                    <div>
                        <router-link :to="{name:'home'}">
                            <img src="@/assets/icons/magor.svg"
                                class="navmenu__logo"
                                alt="Magor"
                                title="Magor">
                        </router-link>
                    </div>
                    <div>
                        <img src="@/assets/icons/menu.svg"
                            @mouseover="openCompleteMenu"
                            @click="openCompleteMenu"
                            class="navmenu__icon"
                            alt="Menu"
                            title="Menu">
                    </div>
                </div>
                <div class="navmenu__menu">
                    <div class="navmenu__menu__list">
                        <ul>
                           <li v-for="(item, index) in menu"
                               :key="index">
                                <router-link :to="{name: item.name}">{{ item.text }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="navmenu__contact">
                        <router-link :to="{name:'contato'}">Contato</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import screenfull from 'screenfull'

export default {
    name: 'navmenu',
    data: () => ({
        completeMenu: true,
        scroll: 0,
        menu: [
            {
                name: 'home',
                text: 'Home',
            },
            {
                name: 'trabalhos',
                text: 'Trabalhos',
            },
            {
                name: 'sobre',
                text: 'Sobre',
            },
            {
                name: 'posts',
                text: 'Blog',
            },
        ],
    }),
    created() {
        window.addEventListener('scroll', () => {
            this.completeMenu = this.canUseCompleteMenu()
        })
    },
    computed: {
        ...mapGetters(['mobileMenu']),
    },
    methods: {
        turnMobileMenu(turn) {
            this.$store.dispatch('stopScrolling', turn)
            this.$store.dispatch('turnMobileMenu', turn)
        },
        openCompleteMenu() {
            this.completeMenu = true
        },
        closeCompleteMenu() {
            this.completeMenu = false
        },
        canUseCompleteMenu() {
            return this.$route.name === 'home'
                    ? window.pageYOffset < window.screen.height
                    : window.pageYOffset === 0
        },
        mouseLeaveHandler() {
            if(this.canUseCompleteMenu())
                return

            this.closeCompleteMenu()
        },
        toggleFullScreen(turn) {
            if(turn) {
                this.scroll = window.pageYOffset

                screenfull.request()
            } else {
                screenfull.exit()
                setTimeout(()=> window.scroll(0, this.scroll), 0)
            }

        }
    },
}
</script>

<style lang="scss">
@import '../assets/css/vars';

$menuHeight: 8.4rem;
$menuHeightMobile: 6rem;

.navmenu {
    height: $menuHeight;
    @media (max-width: $max-sm) {
        height: $menuHeightMobile;
    }
    .navmenu__icons {
        top: -$menuHeight;
    }
}
.app__page {
    margin-top: $menuHeight;
    @media (max-width: $max-sm) {
        margin-top: $menuHeightMobile;
    }
}
</style>

<style lang="scss" scoped>
@import '../assets/css/vars';
.navmenu {

    $root: &;
    $animationSpeed: .2s;
    $menuPadding: 3.6rem;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 20;
    background-color: #fff;
    transition: background-color $animationSpeed;
    overflow: hidden;

    &--activated {
      @media (max-width: $max-sm) {
        overflow: unset;
      }
    }

    &--completeMenu {
        background-color: #fff;
    }

    &__mobilemenu {
        display: none;

        @media (max-width: $max-sm) {
            overflow-y:scroll;
            display: grid;
            position: relative;
            grid-template-rows: auto 1fr auto;
            padding: 3.5rem 2.4rem 0;
            &--activated {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                z-index: 30;
                height: 100%;
                background: #F5F5F5;
            }
            .navmenu__logo {
                height: 3.3rem;
                width: auto;
            }
            &__content {
                justify-content: center;
                display: flex;
                flex-direction: column;
            }
            &__info {
                text-align: center;
                padding: 2rem 0;
                border-bottom: 1px solid #D8D8D8;
                h1 {
                    color: #FF3C3C;
                    font-size: 2rem;
                    margin-bottom: .4rem;
                    font-weight: 900;
                }
                p {
                    font-weight: 300;
                    color: #505050;
                    font-size: 1.5rem;
                    line-height:2.4rem;
                }
                span {
                    font-size: 2.1rem;
                    font-weight: 900;
                }
                &--telefone {
                    border: 0;
                    p {
                        font-weight: 400;
                    }
                }
            }
            &__list {
                li {
                    font-size: 3rem;
                    font-weight: 900;
                    text-align: center;
                    border-bottom: 1px solid #D8D8D8;
                    &:last-child {
                      border-bottom: 0
                    }
                }
                a {
                    display: block;
                    padding: 2rem 0;
                    color:#FF3C3C;
                    text-decoration: none;
                }
            }
            &__header {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                height: 4.5rem;
                padding-bottom: 1.2rem;
            }
            &__contato {
                height: 10.3rem;
                border-top: 1px solid #D8D8D8;
                padding: 3rem;
            }
            &__close {
                position: absolute;
                top: 0;
                right: 0;
                padding: 2.6rem;
            }
        }
    }

    &__menu {
        display: flex;
        height: inherit;
        &__list {
            overflow: hidden;
            justify-content: center;
            align-items: center;
            display: flex;
            ul {
                transition: opacity $animationSpeed;
                position: relative;
                transition-delay: 0;
                opacity: 0;

                #{$root}__desktop--completeMenu & {
                    opacity: 1;
                    transition-delay: 3*$animationSpeed;
                }
            }
        }
    }
    &__desktop,
    &__mobile {
        height: inherit;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__desktop {
        @media (max-width: $max-sm) {
            display: none;
        }
        ul {
            height: inherit;
        }
        li {
            display: inline-block;
            a {
                display: flex;
                align-items: center;
                text-decoration: none;
                color: #9B9B9B;
                font-size: 1.8rem;
                text-transform: uppercase;
                margin: 0 2.8rem;
            }
        }
    }

    &__mobile {
        padding: 0 25px;
        @media (min-width: $min-md) {
            display: none;
        }
    }

    &__logo {
        width: 14.3rem;
        cursor: pointer;
        @media (max-width: $max-sm) {
            width: 9.1rem;
        }

        #{$root}__desktop--completeMenu & {
            @media (min-width: $min-md) {
            }
        }
    }

    &__icons {
        position: relative;
        margin-left: $menuPadding;
        height: inherit;
        transition: top .2s;
        #{$root}__desktop--completeMenu & {
            top: 0;
        }
        div {
            height: inherit;
            display: flex;
            align-items: center;
        }
    }

    &__icon {
        width: 3.4rem;
        cursor: pointer;
        @media (max-width: $max-sm) {
            width: 2rem;
        }

        #{$root}__desktop--completeMenu & {
            @media (min-width: $min-md) {
            }
        }
    }

    &__contact {

        align-items: center;
        justify-content: center;
        display: flex;
        background-color: transparent;
        transition: background-color $animationSpeed;
        transition-delay: 2*$animationSpeed;

        #{$root}__desktop--completeMenu & {
            background-color: #000;
        }
        a {
            transition: $animationSpeed;
            transition-delay: 2*$animationSpeed;
            font-size: 1.8rem;
            text-transform: uppercase;
            justify-content: center;
            text-decoration: none;
            justify-content: center;
            display: flex;
            align-items: center;
            color: #000;
            width: 15.2rem;
            height: 4.2rem;
            border: 1px solid #000;
            border-radius: .8rem;
            margin-right: $menuPadding;
            padding-top: .1rem;

            #{$root}__desktop--completeMenu & {
                color: #fff;
                width: 22.4rem;
                height: 100%;
                margin-right: 0;
                background-color: transparent;
            }
        }
    }
}
</style>
